module.exports = __webpack_public_path__ + "static/media/Bicocca - Bordeaux_White.d2b629de.jpg";